<template>
  <router-view />
</template>

<script>
export default {
  name: 'AllowanceIndex'
}
</script>
